import { useQuery } from 'urql'
import { graphql } from 'app/generated/gql'

export const LOCATION_TIMEZONE_QUERY = graphql(`
  query LocationTimezone($id: ID!) {
    location(id: $id) {
      id
      timezone
    }
  }
`)

/**
 * The IANA timezone of a location, e.g. `America/New_York`.
 *
 * For rendering times that belong to a practice rather than to the viewer: appointments carry
 * a bare `HH:mm` wall clock, so the zone is what turns it into an unambiguous timestamp.
 *
 * Every caller issues the same document and variables, so urql's document cache collapses a
 * list of cards on one location into a single request.
 */
export function useLocationTimezone(locationId?: string | null): string | undefined {
  const [{ data }] = useQuery({
    query: LOCATION_TIMEZONE_QUERY,
    variables: { id: locationId! },
    pause: !locationId,
  })

  return data?.location?.timezone ?? undefined
}
